import { getDefaultPath } from '@iso/lib/helpers/url_sync';
import actions, { getView } from './actions';
import { isServer } from '@iso/lib/helpers/isServer';
import authActions from '../auth/actions';

const preKeys = getDefaultPath();
const initState = {
  // collapsed: true,
  collapsed: !isServer && window.innerWidth > 1220 ? false : true,
  view: !isServer && getView(window.innerWidth),
  height: !isServer && window.innerHeight,
  openDrawer: false,
  openKeys: preKeys,
  current: preKeys,
  appItem: null,
  currentPage: null,
  currentAction: null,

  systemLogsLoading: false,
  systemLogsIsError: false,

  isPageCollapsed: false,

  reminderTrigger: false,
  reminderTriggerTitle: null,
  reminderTriggerMessage: null,

  generateReportProgress: 0,
  generateReportMessage: null,
  generateReportFileId: null,
  generateReportStatus: null,
  generateReportStatuses: [],

  generateSRFTransactionReportTitle: null,
  generateSRFTransactionReportMessage: null,
  generateSRFTransactionReportStatus: null
};

export default function appReducer(state = initState, action) {
  switch (action.type) {
    case actions.COLLPSE_CHANGE:
      return {
        ...state,
        collapsed: state.collapsed,
        openDrawer: !state.openDrawer
      };
    case actions.COLLPSE_OPEN_DRAWER:
      return {
        ...state,
        openDrawer: !state.openDrawer
      };
    case actions.TOGGLE_DRAWER:
      return {
        ...state,
        collapsed: false
      };
    case actions.CLOSE_DRAWER:
      return {
        ...state,
        collapsed: true,
        openDrawer: false
      };
    case actions.TOGGLE_ALL:
      if (state.view !== action.view || action.height !== state.height) {
        const height = action.height ? action.height : state.height;
        return {
          ...state,
          collapsed: action.collapsed,
          view: action.view,
          height
        };
      }
      break;
    case actions.TOGGLE_COLLAPSED_MODULES:
      if (state.collapsed && !state.openDrawer) {
        return {
          ...state,
          collapsed: false,
          openDrawer: false
        };
      } else {
        return {
          ...state,
          collapsed: true,
          openDrawer: true
        };
      }
    case actions.TOGGLE_COLLAPSED_PAGE:
      return {
        ...state,
        isPageCollapsed: action.collapsed ?? !state.isPageCollapsed
      };
    case actions.CHANGE_OPEN_KEYS:
      return {
        ...state,
        openKeys: action.openKeys
      };
    case actions.CHANGE_CURRENT:
      return {
        ...state,
        current: action.current
      };
    case actions.CLEAR_MENU:
      return {
        ...state,
        openKeys: [],
        current: []
      };
    case actions.APP_ITEM_CHANGED:
      return {
        ...state,
        appItem: action.item
      };

    case actions.APPLY_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload
      };
    case actions.SET_CURRENT_ACTION:
      return {
        ...state,
        currentAction: action.payload
      };

    case actions.CLEAR_CURRENT_ACTION:
      return {
        ...state,
        currentAction: null
      };

    case authActions.LOGOUT:
      // reset all redux param values
      return initState;

    case actions.ADDING_SYSTEM_LOGS:
      return {
        ...state,
        systemLogsIsError: false,
        systemLogsLoading: true,
        pageLoading: true
      };

    case actions.ADD_SYSTEM_LOGS_SUCCESS:
      return {
        ...state,
        systemLogsLoading: action.loading,
        errorMessage: action.message,
        systemLogsIsError: false,
        pageLoading: false
      };

    case actions.ADD_SYSTEM_LOGS_FAILED:
      return {
        ...state,
        systemLogsLoading: action.loading,
        errorMessage: action.message,
        systemLogsIsError: true,
        pageLoading: false
      };

    case actions.SET_NOTIFICATION_REMINDER:
      return {
        ...state,
        reminderTrigger: action.payload && action.payload.success ? action.payload.success : false,
        reminderTriggerTitle: action.payload && action.payload.title ? action.payload.title : null,
        reminderTriggerMessage:
          action.payload && action.payload.message ? action.payload.message : null
      };

    case actions.GENERATE_REPORT_STATUS:
      const progress = action?.payload?.percent ?? 30;
      const status = action?.payload?.status;
      const message =
        action?.payload?.message ??
        (progress === 100 ? 'Successfully generated report' : 'Generating report...');
      const fileName = action?.payload?.file_name;
      const fileID = action?.payload?.file_id;

      const newGenerateReportStatuses = state.generateReportStatuses.some(
        item => item.key === action?.payload?.key
      )
        ? state.generateReportStatuses.map(item =>
            item.key === action?.payload?.key
              ? {
                  ...item,
                  generateReportProgress: progress,
                  generateReportMessage: message,
                  generateReportStatus: status,
                  fileName,
                  fileID
                }
              : item
          ) // Update the object if it exists
        : [
            ...state.generateReportStatuses,
            {
              generateReportProgress: progress,
              generateReportMessage: message,
              generateReportStatus: status,
              key: action?.payload?.key,
              fileID,
              fileName
            }
          ];
      return {
        ...state,
        generateReportProgress: progress,
        generateReportMessage: message,
        generateReportStatus: status,
        generateReportStatuses: newGenerateReportStatuses
      };

    case actions.RESET_GENERATE_REPORT:
      return {
        ...state,
        generateReportProgress: 0,
        generateReportMessage: null,
        generateReportStatus: null
      };

    case actions.REMOVE_GENERATE_REPORT_STATUS:
      const key = action?.key ?? '';
      return {
        ...state,
        generateReportStatuses: state.generateReportStatuses.filter(item => item.key !== key)
      };

    case actions.GENERATE_SRF_TRANSACTION_REPORT_STATUS:
      return {
        ...state,
        generateSRFTransactionReportTitle: action?.payload?.title ?? null,
        generateSRFTransactionReportStatus: action?.payload?.status ?? null,
        generateSRFTransactionReportMessage: action?.payload?.message ?? null
      };

    default:
      return state;
  }
  return state;
}
